import { createFileRoute } from "@tanstack/react-router";
import { categoryHead } from "@/lib/seo";
import { CategoryHero } from "@/components/CategoryHero";
import { ProductGrid } from "@/components/ProductGrid";
import { useCollectionProducts } from "@/lib/use-catalog";
import { swimwearProducts } from "@/lib/catalog";
const maillotsAsset = { url: "/img/maillots-de-bain.webp" };

export const Route = createFileRoute("/maillots")({
  head: () =>
    categoryHead({
      path: "/maillots",
      title: "Maillots de Bain Femme au Maroc | SUNSET",
      description:
        "Maillots de bain, bikinis et ensembles maillot & paréo. Dès 429 DH, livraison partout au Maroc et paiement à la livraison.",
      socialDescription:
        "Bikinis, une-pièces et ensembles maillot & paréo SUNSET Concept Store. Paiement à la livraison.",
      name: "Maillots de bain",
      image: "/og/maillots.jpg",
      imageAlt: "Maillots de bain et bikinis Sunset Concept Store",
      products: swimwearProducts,
    }),
  component: MaillotsPage,
});

function MaillotsPage() {
  const products = useCollectionProducts("/maillots", swimwearProducts, /maillot/i);
  return (
    <>
      <CategoryHero
        image={maillotsAsset.url}
        imageAlt="Maillots de bain Sunset Concept Store"
        eyebrow="Collection"
        title="Maillots de bain"
        subtitle="Bikinis, une-pièces et ensembles assortis pour toutes vos journées au soleil."
        imagePosition="sm:object-[50%_40%]"
      />
      <ProductGrid
        products={products}
        placeholderCount={8}
        title="Nos maillots de bain"
        eyebrow="Nouveautés"
        subtitle="Des coupes flatteuses et des imprimés solaires."
        emptyMessage={
          <>
            <p className="text-sm text-muted-foreground sm:text-base">
              La collection Maillots de bain sera bientôt en ligne.
            </p>
            <p className="label-xs mt-3 text-accent">Revenez très vite</p>
          </>
        }
      />
    </>
  );
}
